/* תעודה גמולוגית ב-100 ₪ (07/10/2026) — ראו snippets/marabu-cert-offer + marabu-cert-cart.
   עמוד מוצר: התיבה מסומנת → מוסיפים את התעודה לסל ורק אז נותנים לטופס
   להמשיך (מאזין capture על document — רץ לפני ה-handler של product-form).
   סל: כפתור "הוספת תעודה" מוסיף ומרנדר מחדש את המגירה / טוען מחדש את /cart. */
(function () {
  var he = (document.documentElement.lang || 'he').slice(0, 2) === 'he';
  var KEY = he ? 'עבור' : 'For';

  function addCert(vid, label, sections) {
    var props = {}; props[KEY] = label;
    var body = { items: [{ id: Number(vid), quantity: 1, properties: props }] };
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function labelFor(form, box) {
    var title = box.dataset.certTitle || '';
    var idInput = form.querySelector('[name="id"]');
    var map = {};
    try { map = JSON.parse((form.querySelector('.marabu-cert__variants') || {}).textContent || '{}'); } catch (e) {}
    var vt = idInput && map[idInput.value];
    return vt && vt !== 'Default Title' ? title + ' · ' + vt : title;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (form.dataset.certDone) { delete form.dataset.certDone; return; }
    var box = form.querySelector('.marabu-cert__check');
    if (!box || !box.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var go = function () {
      box.checked = false;
      form.dataset.certDone = '1';
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    };
    addCert(box.dataset.certVariant, labelFor(form, box)).then(go, go);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.marabu-cert-add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    var drawer = btn.closest('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : null;
    addCert(btn.dataset.certVariant, btn.dataset.certFor, sections).then(function (res) {
      if (drawer && res && res.sections) drawer.renderContents(res);
      else window.location.reload();
    }, function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });
})();
